import { createContext } from 'react';

const AdministrarContext = createContext();

export default AdministrarContext;
